import { AppLanguageEnum, getAbbreviationsByAppLanguageEnum } from 'localization/appLanguage';
import { insectControlAddressRoute } from 'route/routeInsectControl';
import { useHistory } from 'react-router-dom';
import i18next from 'i18next';
import React, { useEffect } from 'react';

const InsectControlLb: React.FC<{}> = () => {
    const history = useHistory();

    useEffect(() => {
        i18next.changeLanguage(getAbbreviationsByAppLanguageEnum(AppLanguageEnum.luxembourgish)).then(() => {
            history.push(insectControlAddressRoute.url());
        });
    }, [history]);

    return null;
};

export default InsectControlLb;
